import { render, staticRenderFns } from "./serveCompanyDetail.vue?vue&type=template&id=6849e063&scoped=true&"
import script from "./serveCompanyDetail.vue?vue&type=script&lang=js&"
export * from "./serveCompanyDetail.vue?vue&type=script&lang=js&"
import style0 from "./serveCompanyDetail.vue?vue&type=style&index=0&id=6849e063&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6849e063",
  null
  
)

export default component.exports